export const createClienteModel = ({
  id_interno = '',
  id_cliente = '',
  tipo_pessoa = 'F',
  razao_social = '',
  nome_fantasia = '',
  cpf_cnpj = '',
  rg_ie = '',
  inscricao_municipal = '',
  contato = '',
  telefone = '',
  telefones = [],
  email = '',
  emails = [],
  endereco = '',
  enderecos = [],
  numero_endereco = '',
  complemento = '',
  ponto_referencia = '',
  bairro = '',
  cidade = '',
  cep = '',
  id_colaborador = '',
  colaborador = '',
  id_tabela_preco = '',
  tabela_preco = '',
  id_condicao_pagamento = '',
  condicao_pagamento = '',
  limite_credito = '',
  financeiro
} = {}) => ({
  id_interno,
  id_cliente,
  tipo_pessoa,
  razao_social,
  nome_fantasia,
  cpf_cnpj,
  rg_ie,
  inscricao_municipal,
  contato,
  telefone,
  telefones,
  email,
  emails,
  endereco,
  enderecos,
  numero_endereco,
  complemento,
  ponto_referencia,
  bairro,
  cidade,
  cep,
  id_colaborador,
  colaborador,
  id_tabela_preco,
  tabela_preco,
  id_condicao_pagamento,
  condicao_pagamento,
  limite_credito,
  financeiro
});